<template>
    <div class="search-bar">
        <div class="d-flex align-items-center">
            <label class="mr-sm-2 mb-0">Pencarian</label>
            <form class="form-inline d-flex flex-wrap">
                <div class="form-group mb-0">
                    <input type="text" style="min-width: 200px;" v-model="searchText" class="form-control" @keyup.enter="doSearch"
                        placeholder="kode..." data-lpignore="true">
                </div>
                <div class="form-group mb-0">
                    <date-picker v-model="searchDate" range type="date" placeholder="Tanggal" :editable="false" format="DD-MM-YYYY"></date-picker>
                </div>
                <div class="input-group mr-1">
                    <multiselect class="w-auto flex-grow-1" v-model="searchSupplier" :options="supplierOptions" :placeholder="'Pilih supplier'" :searchable="true"
                        label="name" track-by="id" :show-labels="false"></multiselect>
                    <div class="input-group-append">
                        <button class="btn btn-primary" type="button" @click="selectSupplier = true"><i class="fas fa-search"></i></button>
                    </div>
                </div>
                <div class="form-group mb-0">
                    <button class="btn btn-primary" @click.prevent="doSearch">Cari</button>
                    <button class="btn btn-light" @click.prevent="resetSearch">Reset</button>
                </div>
            </form>
        </div>

        <b-modal v-model="selectSupplier" size="lg" :hide-header="true" :hide-footer="true">
            <supplier-selector :selected="supplierOptions" @selected="supplierSelected" @cancel="selectSupplier = false"></supplier-selector>
        </b-modal>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';
import SupplierSelector from '../suppliers/Selector';

export default {
    components: {
        Multiselect,
        DatePicker,
        SupplierSelector,
    },

    data() {
        return {
            selectSupplier: false,
            searchSupplier: null,
            supplierOptions: [],
            searchText: '',
            searchDate: '',
        }
    },

    methods: {
        doSearch() {
            let self = this,
                data = {
                    searchText: self.searchText,
                    searchDate: self.searchDate[0] && self.searchDate[1] ? self.searchDateFormat : null,
                    searchSupplierId: self.searchSupplier ? self.searchSupplier.id : '',
                };
            self.$emit('search-set', data);
        },

        resetSearch() {
            this.searchText = '';
            this.searchDate = '';
            this.searchSupplier = null;
            this.$emit('search-reset');
        },

        supplierSelected(supplier) {
            let self = this;

            self.supplierOptions.push(supplier);
            self.searchSupplier = Object.assign({}, supplier);
            self.selectSupplier = false;
        },
    }
}
</script>
<style>
.search-bar {
    padding: 10px;
}
</style>
